/*
 * Copyright (c) 2024. Haodong JU
 */
import hillo from 'hillo'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'

export const reservationHost = 'https://reservation-api.aaden.io/'

// const host = 'http://localhost/'

export async function addTableReserve (id) {
  return (await hillo.post('Tables.php?op=addToReservable',
    { tableId: id }))
}

export async function removeTableReserve (id) {
  return (await hillo.post('Tables.php?op=removeFromReservable',
    { tableId: id }))
}

export async function getReserveTable () {
  return (await hillo.get('Tables.php?op=getAllReservable')).content
}

export async function getReserveSettings () {
  return (await hillo.get('Tables.php?op=getReserveSettings')).content
}

export async function editReserveDefaultUsefulTime (item) {
  return (await hillo.post('Tables.php?op=editTableReserveEDT', { ...item }))
}

export async function getReservationUserList () {
  return (await hillo.post(reservationHost + 'user/getList', {})).data
}

export async function ifReserveOpen () {
  return (JSON.parse((await hillo.post('Tables.php?op=checkUserAvailable', {
    overrideServer: reservationHost + 'user/check'
  }, { silent: true })).content).code === 200)
}

export async function addUserInfo (item) {
  return (await hillo.post('Tables.php?op=addUserInfo', {
    ...item,
    overrideServer: reservationHost + 'user/onNotify',
    notifyType: 'added'
  })).content
}

export async function editUserInfo (item) {
  return (await hillo.post('Tables.php?op=addUserInfo', {
    ...item,
    overrideServer: reservationHost + 'user/onNotify',
    notifyType: 'changed'
  })).content
}

export async function getReservationStatus () {
  const userId = parseInt(await getCurrentDeviceId())
  return (await hillo.get('https://reservation-api.aaden.io/user/getDetail/' + userId)).data
}
